import LanguageInput from './LanguageInput'

export default LanguageInput